import { axiosInstance } from "@src/utils/axios/AxiosProvider";

interface DataType {
  apiKey?: string;
  expectedTransactionTypes: number[];
  birthDate?: string;
  documentBackSide?: string;
  documentFrontSide?: string;
  documentType?: string;
  selfImage?: string;
  name?: string;
  personalID?: string;
  surname?: string;
  termID?: number;
  employmentStatusCode?: string;
  worktypes?: string[];
  employer?: string;
  workPosition?: string;
  // business
  employmentStatusBusinesOwnerType: string;
  employmentEntrepreneurWorkType: string;
  employmentEntrepreneurWorkTypeOther: string;
  employmentLegalWorkType: string;
  employmentLegalCustomerINN: string;
  employmentLegalName: string;
  employmentLegalWorkTypeOther: string;
  expectedTurnoverCode?: string;
  citizenshipCountryID?: number;
  passportNumber?: string;
  isResident?: true;
  factCountryID?: number;
  factCity?: string;
  factCityID?: number;
  factAddress?: string;
  factPostalCode?: string;
  secondaryCitizenshipCountryID?: number;
  legalCountryID?: number;
  legalCityID?: number;
  legalCity?: string;
  legalAddress?: string;
  legalPostalCode?: string;
  sex?: number;
  birthCountryId?: number;
  birthCity?: string;
  birthCityId?: number;
  phone?: string;
  issueDate?: string;
  validTo?: string;
  authority?: string;
  sourceOfIncomeCodes: string[];
  sourceOfIncomeOther: string;
  monthlyIncomeCode: string;
  pepType: string;
  pepPosition: string;
  pepConnectionType: string;
  pepName: string;
  pepSurname: string;
}

export const saveCustomerApiCall = async ({ apiKey, ...data }: DataType) => {
  const response = await axiosInstance.post<unknown>("/api/customer", data, {
    headers: {
      "x-api-key": apiKey,
    },
  });
  return response.data;
};
